import React from 'react';
import PropTypes from 'prop-types';

const Loader = () => (
  <div className="modal_wrapper">
    <table className="modal_bg">
      <tbody>
        <tr>
          <td className="modal_wp">
            <span className="loading_img">
              <img src="/assets/loader_blk_lrg.gif" alt="loader"/>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

Loader.propTypes = {
  className: PropTypes.string
};

export default Loader;
